<template>
  <div class="container">
    <p class="top">找教练，赢iPad！找到你身边的健身教练，并邀请他下载老虎教练，体验工作效率提升百倍的乐趣，还能获得各种精美超值大礼，包括iPad一台！</p>
    <p class="content"><b>活动名称:</b> <br> 邀教练 赢iPad</p>
    <p class="content"><b>参与方式:</b> <br> 
    1、用户通过登录“老虎教练APP”，点击首页“赢免费iPad”参与活动(未使用微信登陆APP的用户需先绑定微信登陆方可参与)<br>
    2、关注“老虎运动”微信公众号，至公众号底部菜单栏—“赢免费iPad”参与活动
    </p>
    <p class="content"><b>邀请规则:</b> <br> 
    1、通过邀请链接或面对面扫码邀请朋友下载 <br>
    2、被邀请人下载登录填写邀请人的邀请码，双方即可同时获得价值39元无消费门槛虎皮商城代金券一张                
    </p>
    <p class="content"><b>奖品设置:</b> <br> 
    1、邀请1人下载注册登录：邀请人与被邀请人同时获得价值39元无消费门槛虎皮商城代金券一张 <br>
    2、累计邀请5人并完成认证：邀请人获得价值300元的劳拉之星牛皮腰带一条，领完为止 <br>
    3、累计邀请10人并完成认证：邀请人获得价值900元的Phoenix筋膜枪一个，领完为止 <br>
    4、累计邀请20人并完成认证：邀请人获得价值3896元的ipad Air一台（64GB无线局域网机型），领完为止                                
    </p>
    <p class="content"><b>认证流程:</b></p> 
    <div class="display">
      <p>1 打开“老虎教练”App  点击头像进入个人中心</p>
      <div class="display_x">
        <img class="x_1" src="../../assets/WechatIMG8.png" alt="">
        <img class="x_2" src="../../assets/shape01.png" alt="">
        <img class="x_3" src="../../assets/rules02.png" alt="">
      </div>
      <p>2 进入个人中心 选择工作信息</p>
      <div class="display_y">
        <img class="y_1" src="../../assets/WechatIMG7@2x.png" alt="">
        <img class="y_2" src="../../assets/shape02@2x.png" alt="">
        <img class="y_3" src="../../assets/shape03@2x.png" alt="">
        <img class="y_4" src="../../assets/rules01@2x.png" alt="">
        <img class="y_5" src="../../assets/rules03@2x.png" alt="">
      </div>
      <p>3 去认证，审核通过后认证即成功</p>
      <div class="display_z">
        <img class="z_1" src="../../assets/WechatIMG9@2x.png" alt="">
      </div>
    </div>
    <p class="content"><b>奖品领取:</b> <br> 
    1.39元代金券可在微信小程序"<b>虎皮商店</b>"中使用，购买时填写优惠码即可享受39元优惠 <br>
    2.劳拉之星牛皮腰带、Phoenix筋膜枪、iPad Air的领取，请添加<b>老虎运动客服微信号"Laohujiaolian"，在客服处进行核对与领奖(为了信息核对有效和保证您顺利领奖，参与活动期间请勿更改微信头像和昵称)</b>
    </p>
    <p class="content"><b>注意事项:</b> <br> 
    1、如发现用户以任何不正当手段或舞弊方式参与本活动，本平台有权采取限制登录、封禁账号、撤消活动资格、追讨所造成损失，并依法移交相关法律机关进行处理。<br>
    2、本次活动如因不可抗力、相关政策、活动调整等原因导致本次活动调整、暂停举办或无法进行的，本平台有权随时决定修改、暂停、取消或终止本活动，并无需为此承担任何法律责任。<br>
    3、如因第三方各种不当手段攻击、破坏、造成用户无法参与或参与失败的，本平台无需为此承担任何法律责任。<br>
    4、在法律允许的范围内，本平台有权对本活动规则进行变动或调整。相关变动或调整将公布在活动规则页面上，并于公布时即时生效，用户继续参与该活动则视为对前述变动或者调整后的活动规则予以同意。如果用户拒绝上述活动规则的变更或者调整，应停止参与变更后的该活动。
                        
    </p>
  </div>
</template>

<script>
  export default {
      name: "activityRules"
  }
</script>

<style lang="less" scoped>
  .container {
    width: 100%;
    height: 100vh;
    color: #000;
    overflow: auto;
    .top {
      margin: 0.15rem 0.15rem 0.25rem;
      line-height: 0.18rem;
      font-size: 0.12rem;
      font-weight: 400;
    }
    .content {
      margin: 0 0.15rem 0.25rem;
      line-height: 0.18rem;
      font-size: 0.12rem;
      font-weight: 400;
    }
    h6 {
      margin-left: 0.15rem;
    }
    .display {
      margin: 0 0.15rem;
      p {
        line-height: 0.18rem;
        font-size: 0.12rem;
        font-weight: 400;
      }
      .display_x {
        width: 100%;
        height: 2.33rem;
        position: relative;
        .x_1 {
          width: 1.23rem;
          height: 2.18rem;
          margin: 0.06rem 0.21rem 0.08rem;
        }
        .x_2 {
          position: absolute;
          top: 0.18rem;
          left: 0.3rem;
          width: 1.67rem;
          height: 1.05rem;
        }
        .x_3 {
          position: absolute;
          top: 0.5rem;
          left: 2rem;
          width: 1.24rem;
          height: 1.24rem;
        }
      }
      .display_y {
        width: 100%;
        height: 2.33rem;
        position: relative;
        .y_1 {
          width: 1.23rem;
          height: 2.18rem;
          margin: 0.06rem 0.21rem 0.08rem;
        }
        .y_2 {
          position: absolute;
          top: 0.8rem;
          left: 1.1rem;
          width: 0.89rem;
          height: 0.62rem;
        }
        .y_3 {
          position: absolute;
          bottom: 0.3rem;
          left: 1.1rem;
          width: 0.45rem;
          height: 0.16rem;
        }
        .y_4 {
          position: absolute;
          top: 0.5rem;
          left: 2rem;
          width: 1.24rem;
          height: 1.24rem;
        }
        .y_5 {
          position: absolute;
          bottom: 0.2rem;
          left: 1.6rem;
          width: 0.46rem;
          height: 0.46rem;
        }
      }
      .display_z {
        width: 100%;
        height: 2.33rem;
        position: relative;
        .z_1 {
          width: 1.23rem;
          height: 2.18rem;
          margin: 0.06rem 0.21rem 0.08rem;
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/views/activityRules/index.vue